import { render, staticRenderFns } from "./adetail.vue?vue&type=template&id=862fbf3c&scoped=true&"
import script from "./adetail.vue?vue&type=script&lang=js&"
export * from "./adetail.vue?vue&type=script&lang=js&"
import style0 from "./adetail.vue?vue&type=style&index=0&id=862fbf3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862fbf3c",
  null
  
)

export default component.exports